/**
 * Static Safety Tips and Guidelines for Skincare
 * These are generic, dermatologist-quality tips that apply to all users
 */

const safetyTips = {
  disclaimer: "This is not medical advice. If you have persistent skin issues, severe conditions, or adverse reactions, please consult a board-certified dermatologist. Results vary by individual.",

  safety_notes: [
    "Patch test all new products on your inner forearm for 24-48 hours before applying to your face",
    "Introduce only ONE new product at a time, waiting 1-2 weeks before adding another to identify any reactions",
    "If using retinoids or acids for the first time, start with 2x per week and gradually increase frequency",
    "Always apply sunscreen as the last step in your morning routine, even on cloudy days",
    "Stop using any product immediately if you experience severe redness, burning, swelling, or persistent irritation",
    "Avoid using multiple active ingredients (retinoids, acids, vitamin C) together when first starting out",
    "Keep products away from direct sunlight and store them in a cool, dry place",
    "Check expiration dates and replace products that have changed color, smell, or texture"
  ],

  application_tips: [
    "Apply products from thinnest to thickest consistency for best absorption",
    "Wait 1-2 minutes between applying water-based serums and oil-based products",
    "Use gentle upward motions when applying products to avoid tugging on delicate facial skin",
    "Don't forget your neck and the back of your hands - they show aging too",
    "Apply eye cream using your ring finger (lightest touch) and gently pat, don't rub",
    "If using vitamin C in the morning, wait 10-15 minutes before applying sunscreen",
    "Use a pea-sized amount for most serums and treatments - more isn't always better",
    "Apply sunscreen generously - use about a nickel-sized amount for your face",
    "Cleanse your face for at least 60 seconds to ensure proper removal of dirt and makeup",
    "Always apply products to slightly damp skin for better absorption (except for retinoids)"
  ],

  additional_tips: [
    "Reapply sunscreen every 2-3 hours if you're outdoors or sitting near windows",
    "Take progress photos in the same lighting every 2 weeks to accurately track improvements",
    "Drink plenty of water throughout the day - hydration starts from within",
    "Change your pillowcase at least twice a week to prevent bacteria buildup",
    "Clean your phone screen regularly as it touches your face frequently",
    "Avoid touching your face throughout the day to minimize bacteria transfer",
    "Be patient - most skincare products take 4-12 weeks to show visible results",
    "Maintain a consistent routine - skipping steps can slow down progress",
    "If you have hard water in your area, consider using micellar water as a first cleanse",
    "In high humidity, use lighter products; in dry climates, layer more hydrating products",
    "Protect your skin from pollution by cleansing thoroughly every evening",
    "Keep your skincare routine simple - your skin doesn't need 10+ products to be healthy"
  ],

  purging_vs_reaction: "When introducing new active ingredients (especially acids, retinoids, or vitamin C), mild 'purging' is normal - this means small breakouts in areas where you typically get acne, lasting 2-4 weeks as your skin cell turnover increases. However, stop using the product immediately if you experience severe redness, burning sensation, swelling, hives, or rash in new areas - these indicate an adverse allergic reaction, not purging. If you're unsure, consult a dermatologist.",

  when_to_see_doctor: "Consult a dermatologist if you experience persistent acne despite following a routine for 3+ months, sudden severe breakouts, painful cystic acne, signs of skin infection (oozing, crusting, fever), extreme sensitivity or reactions to multiple products, rapidly spreading pigmentation, or any concerning skin changes. Professional medical advice is essential for serious skin conditions."
};

export default safetyTips;
